export const getObjectByValue = (objs, value) => {
    if (objs ==='') return '';
        
    return objs.find( o => o.value === value);
}

export const DEFAULT_IMAGE_PROFILE = { "F" : "https://alumni-images.s3.us-east-2.amazonaws.com/female-default.jpg" ,
                        "M" : "https://alumni-images.s3.us-east-2.amazonaws.com/male-default.jpg",
                        "O" : "https://alumni-images.s3.us-east-2.amazonaws.com/unknown-default.jpg",
                    }

export const STATES = [
      { value:'OT', label: 'Otro'},
      { value:'BS' , label: 'Buenos Aires' },
      { value:'CA' , label: 'Catamarca' },
      { value:'CH' , label: 'Chaco' },
      { value:'CT' , label: 'Chubut' },
      { value:'BA' , label: 'Ciudad Autónoma de Buenos Aires' },
      { value:'CO' , label: 'Córdoba' },
      { value:'CR' , label: 'Corrientes' },
      { value:'ER' , label: 'Entre Ríos' },
      { value:'FO' , label: 'Formosa' },
      { value:'JY' , label: 'Jujuy' },
      { value:'LP' , label: 'La Pampa' },
      { value:'LR' , label: 'La Rioja' },
      { value:'MZ' , label: 'Mendoza' },
      { value:'MI' , label: 'Misiones' },
      { value:'NQ' , label: 'Neuquén' },
      { value:'RN' , label: 'Río Negro' },
      { value:'SA' , label: 'Salta' },
      { value:'SJ' , label: 'San Juan' },
      { value:'SL' , label: 'San Luis' },
      { value:'SC' , label: 'Santa Cruz' },
      { value:'SF' , label: 'Santa Fe' },
      { value:'SE' , label: 'Santiago del Estero' },
      { value:'TF' , label: 'Tierra del Fuego' },
      { value:'TU' , label: 'Tucumán' } ];


export const COUNTRIES = [
    { value:'14', label: 'Argentina'}, 
    { value:'30', label: 'Bolivia'}, 
    { value:'34', label: 'Brasil'}, 
    { value:'47', label: 'Chile'}, 
    { value:'48', label: 'China'}, 
    { value:'66', label: 'República Dominicana'}, 
    { value:'172', label: 'Paraguay'}, 
    { value:'173', label: 'Peru'}, 
    { value:'211', label: 'Tailandia'}, 
    { value:'229', label: 'Uruguay'}, 
    { value:'232', label: 'Venezuela'} 
];

export const USER_DOC_TYPES = [
    { value:'DNI', label: 'DNI' }, 
    { value:'PAS', label: 'Pasaporte' }, 
    { value:'CI', label: 'Cedula de Identidad' }, 
    { value:'OTR', label: 'Otro' }, 
    { value:'TRA', label: 'En trámite' }
];

export const USER_GENDERS = [
    { value:'F', label: 'Femenino' }, 
    { value:'M', label: 'Masculino' },
    { value:'O', label: 'Otro'}
];

export const SEARCH_TYPES = [
    { value:'AL', label: 'Alumno' }, 
    { value:'CU', label: 'Curso' },
    { value:'TO', label: 'Todo el registro' },
     
];

export const RELATIONS_TYPES = [
    { value:"1", label: "Otros"} ,
    { value:"2", label: "Tutor"} ,
    { value:"3", label: "Padre"} ,
    { value:"4", label: "Madre"} ,
    { value:"5", label: "Abuelo"} ,
    { value:"6", label: "Abuela"},
    { value:"7", label: "Resp.Económico"}] ;


export const MONTHS = [ 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 
                        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ];

export const MONTHS_SHORT = [ 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 
                        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic' ];

export const MONTHS_DAYS = [ 31, 28, 31,30,31,30,31,31,30,31,30,31 ];

export const WEEK_DAYS = [ 'Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
export const WEEK_DAYS_SHORT = [ 'Dom','Lun','Mar','Mie','Jue','Vie','Sab'];

export const WEEK_DAYS_MATRIX = [
    { value:"1", label: "Dom"} ,
    { value:"2", label: "Lun"} ,
    { value:"3", label: "Mar"} ,
    { value:"4", label: "Mie"} ,
    { value:"5", label: "Jue"} ,
    { value:"6", label: "Vie"} ,
    { value:"7", label: "Sab"} ] ;


export const PERSONA_TYPES = [
    { value:'S', label: 'Alumno' }, 
    { value:'R', label: 'Pariente' }
    // ,
    // { value:'E', label: 'Empleado'}
    ];
    
export const EVALUATION_TYPES = [
    { value: "NUM", label: "Nota numérica"}, 
    { value: "CON", label: "Trayectoria conceptual"}
]

export const TOP_LEVELS = [
    { value: "KIN", label: "Inicial"},
    { value: "PRIM", label: "Primaria"}, 
    { value: "SEC", label: "Secundaria"},
    
    
]

export const SCHOOL_SHIFTS = [
    { value: "18", label: "Mañana"}, 
    { value: "19", label: "Tarde"}
]

export const YES_NO = [
    { value: "Y", label: "Si"}, 
    { value: "N", label: "No"}
]